import { AxiosError } from "axios";

import {
  ForkEffect,
  call,
  put,
  putResolve,
  select,
  takeLeading,
} from "redux-saga/effects";
import { setBaseUrl } from "../../redux/Consts";
import { authDTO, authNoTokenDTO } from "../../redux/auth";
import {
  getAuthDataFailure,
  getAuthDataSuccess,
  logoutNewFailure,
  logoutNewSuccess,
  rotateFailure,
  rotateSuccess,
  setIsAuthenticated,
  setIsBaseURLRetrieved,
  signInCheckResult,
  signInFailure,
  signInPasswordlessFailure,
  signInPasswordlessFinishFailure,
  signInPasswordlessFinishSuccess,
  signInPasswordlessSuccess,
  signInSuccess,
} from "../../redux/auth/actions";
import {
  AUTHENTICATION,
  ILogoutNew,
  ISignInCheck,
  ISingIn,
  ISingInPasswordless,
  ISingInPasswordlessFinish,
} from "../../redux/auth/types";
import { needToNotifyLogin } from "../../redux/healthCheck/actions";
import { HEALTH_CHECK } from "../../redux/healthCheck/types";
import { setOrganizationIdFromToken } from "../../redux/organization/actions";
import { IAppState } from "../../redux/types";
import { setUserDataFromAuth } from "../../redux/userProfile/actions";
import { history } from "../../routes/BrowserHistory";
import { AxiosCustom } from "../../service/Axios";
import { StorageHelper } from "../../utils/StorageHelper";
import { validateEmail } from "../../utils/links";
import { setLoggedIn } from "../../utils/pushNotification/NativeInteractor";
import {
  notifyLoginLogoutSaga,
  unregisterMobileDeviceAsTagSaga,
  unsubscribeSaga,
} from "../healthCheck/healthCheckSaga";

export function* getAuthDataWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(AUTHENTICATION.GET_AUTH_DATA, getAuthDataSaga);
}

function* getAuthDataSaga() {
  try {
    const resultCall = yield call(() => AxiosCustom.getAuthData());
    const result: authNoTokenDTO = resultCall.data;
    yield put(setOrganizationIdFromToken(parseInt(result.organizationId)));
    yield put(setUserDataFromAuth(result));

    const resultParse = JSON.parse(result.region.toLowerCase());
    setBaseUrl(resultParse?.url);
    yield put(setIsBaseURLRetrieved(true));

    yield put(setIsAuthenticated(true));
    yield putResolve(getAuthDataSuccess(result));
  } catch (error) {
    const e = error as AxiosError;
    StorageHelper.instance.ClearAccessToken();
    StorageHelper.instance.ClearSocialToken();
    StorageHelper.instance.ClearRegisterEmail();
    yield put(setIsBaseURLRetrieved(false));
    StorageHelper.instance.ClearPage();
    StorageHelper.instance.SaveLoggedOut(true);
    setBaseUrl(undefined);
    yield putResolve(getAuthDataFailure(e));
    console.log("error rotate" + e.message);
  }
}

export function* signInWatcher(): Generator<ForkEffect<never>, void, unknown> {
  yield takeLeading(AUTHENTICATION.SIGN_IN, signInSaga);
}

function* signInSaga(action: ISingIn) {
  try {
    const resultCall = yield call(() =>
      AxiosCustom.loginWithPassword(action.payload)
    );
    const result: authDTO = resultCall.data;

    if (result?.role === "Dev") yield put(signInFailure("wrong cred"));
    else {
      StorageHelper.instance.SaveAccessToken(
        result.accessToken,
        result.expiresIn,
        result.refreshToken
      );
      yield put(setOrganizationIdFromToken(parseInt(result.organizationId)));
      const auth = yield call(() => AxiosCustom.getAuthData());
      const authResult: authNoTokenDTO = auth.data;
      yield put(
        setUserDataFromAuth({
          ...result,
          idetityProviders: authResult.idetityProviders,
        })
      );

      const resultParse = JSON.parse(result.region);
      setBaseUrl(resultParse?.url);
      yield put(setIsBaseURLRetrieved(true));
      yield put(needToNotifyLogin()); //cleaning storages
      yield put(setIsAuthenticated(true));
      yield putResolve(signInSuccess(result));
    }
  } catch (error) {
    const e = error as AxiosError;
    if (JSON.stringify(e?.response?.data).indexOf("block") !== -1) {
    }
    yield putResolve(signInFailure(JSON.stringify(e?.response?.data)));
  }
}

export function* logoutNewWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(AUTHENTICATION.LOGOUT_NEW_REQUEST, logoutSaga);
}

function* logoutSaga(action: ILogoutNew) {
  try {
    const state: IAppState = yield select();
    const isSubscribedMobileId =
      state?.healthCheck?.mobileId ||
      state?.healthCheck?.subscribeData?.mobileId;
    const performCalls = !action.payload.silently;

    if (isSubscribedMobileId && performCalls) {
      try {
        console.log("unsubscribe start " + isSubscribedMobileId);
        yield call(() =>
          unsubscribeSaga({
            type: HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_REQUEST,
            payload: { mobileId: isSubscribedMobileId },
          })
        );

        console.log("unsubscribe success " + isSubscribedMobileId);
      } catch (e) {
        console.log("pns is working badly");
      }
    }

    if (isSubscribedMobileId) {
      // state?.healthCheck?.useMobileDeviceAsWatch && isSubscribedMobileId
      try {
        yield call(() =>
          unregisterMobileDeviceAsTagSaga({
            type: HEALTH_CHECK.UNSUBSCRIBE_USER_MOBILE_DEVICE_REQUEST,
            payload: {
              deviceId: isSubscribedMobileId,
              userId: state.userProfile.id,
            },
          })
        );
      } catch (e) {
        console.log("tag unsubscribe working badly" + JSON.stringify(e));
      }
    }
    if (state?.userProfile?.email && state?.userProfile?.id && performCalls)
      yield call(() =>
        notifyLoginLogoutSaga({
          type: HEALTH_CHECK.NOTIFY_LOGIN_LOGOUT_REQUEST,
          payload: {
            isLogin: false,
            value: {
              email: state.userProfile.email,
              userId: state.userProfile.id,
            },
          },
        })
      );

    console.log("starting clean up");
    setLoggedIn(false);
    if (performCalls) yield call(() => AxiosCustom.logout());
    StorageHelper.instance.ClearAccessToken();
    StorageHelper.instance.ClearSocialToken();
    StorageHelper.instance.ClearRegisterEmail();
    yield put(setIsBaseURLRetrieved(false));
    StorageHelper.instance.ClearPage();
    StorageHelper.instance.SaveLoggedOut(true);
    yield putResolve(logoutNewSuccess(action.payload.redirectTo));
    setBaseUrl(undefined);
  } catch (error) {
    StorageHelper.instance.ClearAccessToken();
    StorageHelper.instance.ClearSocialToken();
    StorageHelper.instance.ClearRegisterEmail();
    yield putResolve(logoutNewFailure());
    //yield put({ type: REQUEST_ERROR, error: error.message });
  }
}

export function forwardTo(location: string) {
  history.push(location);
}

export function* singInCheckWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(AUTHENTICATION.SIGN_IN_CHECK, singInCheckSaga);
}

function* singInCheckSaga(action: ISignInCheck) {
  try {
    yield call(() => AxiosCustom.signInCheck(action.payload));
    const isEmail = validateEmail(action.payload);
    yield putResolve(signInCheckResult(true, isEmail, ""));
  } catch (error) {
    const isEmail = validateEmail(action.payload);
    const e = error as AxiosError;
    if (JSON.stringify(e?.response?.data).indexOf("block") !== -1) {
    }
    yield put(
      signInCheckResult(false, isEmail, JSON.stringify(e?.response?.data))
    );
  }
}

export function* signInPasswordlessWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(AUTHENTICATION.SIGN_IN_PASSWORLESS, signInPasswordlessSaga);
}
function* signInPasswordlessSaga(action: ISingInPasswordless) {
  try {
    yield call(() => AxiosCustom.loginPasswordlessStart(action.payload));

    yield putResolve(signInPasswordlessSuccess(action.payload));
  } catch (error) {
    const e = error as AxiosError;
    yield putResolve(
      signInPasswordlessFailure(JSON.stringify(e?.response?.data))
    );
  }
}
export function* signInPasswordlessEndWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    AUTHENTICATION.SIGN_IN_PASSWORLESS_END,
    signInPasswordlessEndSaga
  );
}

function* signInPasswordlessEndSaga(action: ISingInPasswordlessFinish) {
  try {
    const resultCall = yield call(() =>
      AxiosCustom.loginPasswordlessFinish(action.payload)
    );
    const result: authDTO = resultCall.data;

    if (result?.role === "Dev") yield put(signInFailure("wrong cred"));
    else {
      StorageHelper.instance.SaveAccessToken(
        result.accessToken,
        result.expiresIn,
        result.refreshToken
      );
      yield put(setOrganizationIdFromToken(parseInt(result.organizationId)));
      const auth = yield call(() => AxiosCustom.getAuthData());
      const authResult: authNoTokenDTO = auth.data;
      yield put(
        setUserDataFromAuth({
          ...result,
          idetityProviders: authResult.idetityProviders,
        })
      );

      const resultParse = JSON.parse(result.region);
      setBaseUrl(resultParse?.url);
      yield put(setIsBaseURLRetrieved(true));
      yield put(needToNotifyLogin()); //cleaning storages
      yield put(setIsAuthenticated(true));
      yield putResolve(
        signInPasswordlessFinishSuccess({ ...result, ...action.payload })
      );
    }
  } catch (error) {
    const e = error as AxiosError;
    yield putResolve(signInPasswordlessFinishFailure(e));
  }
}

export function* rotateTokenWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(AUTHENTICATION.ROTATE_TOKEN, rotateTokenSaga);
}

function* rotateTokenSaga() {
  try {
    const resultCall = yield call(() => AxiosCustom.rotateToken());
    const result: authDTO = resultCall.data;
    StorageHelper.instance.SaveAccessToken(
      result.accessToken,
      result.expiresIn,
      result.refreshToken
    );

    yield put(setOrganizationIdFromToken(parseInt(result.organizationId)));
    const auth = yield call(() => AxiosCustom.getAuthData());
    const authResult: authNoTokenDTO = auth.data;
    yield put(
      setUserDataFromAuth({
        ...result,
        idetityProviders: authResult.idetityProviders,
      })
    );

    const resultParse = JSON.parse(result.region);
    setBaseUrl(resultParse?.url);
    yield put(setIsBaseURLRetrieved(true));

    yield put(setIsAuthenticated(true));
    yield putResolve(rotateSuccess(result));
  } catch (error) {
    const e = error as AxiosError;
    yield putResolve(rotateFailure(e));
    yield call(() => AxiosCustom.logout());
    StorageHelper.instance.ClearAccessToken();
    StorageHelper.instance.ClearSocialToken();
    StorageHelper.instance.ClearRegisterEmail();
    yield put(setIsBaseURLRetrieved(false));
    StorageHelper.instance.ClearPage();
    StorageHelper.instance.SaveLoggedOut(true);
    setBaseUrl(undefined);
    console.log("error rotate" + e.message);
  }
}
